import React from "react";
import {
  Row, Col,
  Modal, Button
} from "antd";

import FieldValueVerticalCell from "components/general/FieldValueVerticalCell";
import FieldCountryWithFlag from "components/general/FieldCountryWithFlag";
import ChangePasswordModal from "components/settings/ChangePasswordModal";
import EnterOTPLayout from "components/EnterOTPLayout";
import { formatPhoneNumber } from 'utils/utils'
import _get from "lodash/get";
import moment from "moment";

export default class SetupPaymentTab extends React.Component {
  state = {
    showChangePasswordModal: false,
    showOTPModal: false
  };

  showChangePasswordModal = e => {
    this.setState({ showChangePasswordModal: true });
  };

  hideChangePasswordModal = e => {
    this.setState({ showChangePasswordModal: false });
  };

  render() {
    const { profile } = this.props;
    const { showChangePasswordModal } = this.state;

    return (
      <div className="content-wrapper">
        <div className="banner">
          You cannot change your personal details online because your account has already been
          verified. If you need to change your personal details, please contact
          Brdgx Support Team at
          <a href="mailto:operations@brdgx.com"> operations@brdgx.com</a>
        </div>
        <div className="profile-page-body">
          <div className="personal-profile">
            <h6 className={"fw-600"}>Personal Information</h6>
            <div className="bp-bordered-panel">
              <Row>
                <Col md={6} sm={12}>
                  <FieldValueVerticalCell
                    className="bp-table-cell"
                    title="Reference ID"
                    value={profile.referenceNumber}
                  />
                </Col>
                <Col md={6} sm={12}>
                  <FieldValueVerticalCell
                    className="bp-table-cell"
                    title="Full Name"
                    value={profile.name}
                  />
                </Col>
                <Col md={6} sm={12}>
                  {/*<FieldCountryWithFlag*/}
                  {/*  className="bp-table-cell"*/}
                  {/*  title="Registered Country"*/}
                  {/*  countryCode={profile.countryCode || ""}*/}
                  {/*/>*/}
                  <FieldValueVerticalCell
                      className="bp-table-cell"
                      title="Country of Residence"
                      value={profile.personalAccountDetails.countryOfResidenceName}
                  />
                </Col>
                <Col md={6} sm={12}>
                  <FieldValueVerticalCell
                    className="bp-table-cell"
                    title="Phone Number"
                    value={profile.personalAccountDetails.contactNumber}
                  />
                </Col>
                <Col md={6} sm={12}>
                  <FieldValueVerticalCell
                    className="bp-table-cell"
                    title="Email"
                    value={profile.email}
                  />
                </Col>
                <Col md={6} sm={12}>
                  <FieldValueVerticalCell
                      className="bp-table-cell"
                      title="DOB"
                      value={moment(profile.personalAccountDetails.dateOfBirth).format("DD/MM/YYYY")}
                  />
                </Col>
                <Col md={6} sm={12}>
                  <FieldValueVerticalCell
                      className="bp-table-cell"
                      title="Nationality"
                      value={profile.personalAccountDetails.nationalityName}
                  />
                </Col>
                <Col md={6} sm={12}>
                  <FieldValueVerticalCell
                      className="bp-table-cell"
                      title="ID Number"
                      value={profile.personalAccountDetails.idNumber}
                  />
                </Col>
              </Row>
            </div>
            <h6 className={"fw-600"}>Personal Address</h6>
            <div className="bp-bordered-panel">
              <Row>
                <Col md={6}>
                  <FieldValueVerticalCell
                    className="bp-table-cell"
                    title="Address Line 1"
                    value={profile.personalAccountDetails.addressLine1 || ""}
                  />
                </Col>
                <Col md={6}>
                  <FieldValueVerticalCell
                      className="bp-table-cell"
                      title="Address Line 2"
                      value={profile.personalAccountDetails.addressLine2 || ""}
                  />
                </Col>
                <Col md={6} sm={12}>
                  <FieldValueVerticalCell
                    className="bp-table-cell"
                    title="State/Province"
                    value={profile.personalAccountDetails.cityState || ""}
                  />
                </Col>
                <Col md={6} sm={12}>
                  <FieldValueVerticalCell
                    className="bp-table-cell"
                    title="Postal/Area Code"
                    value={profile.personalAccountDetails.postalCode || ""}
                  />
                </Col>
              </Row>
            </div>
            <h6 className={"fw-600"}>Change Password</h6>
            <div className="bp-bordered-panel">
              <Row>
                <Col md={6} sm={12}>
                  <FieldValueVerticalCell
                    className="bp-table-cell"
                    title="Current Password"
                    value="************"
                  />
                </Col>
                <Col md={6} sm={12}>
                  <div className="change-button">
                    <Button
                      type="primary"
                      onClick={this.showChangePasswordModal}
                      htmlType={"button"}>
                      Change Password
                    </Button>
                  </div>
                </Col>
              </Row>
              <ChangePasswordModal
                visible={showChangePasswordModal}
                onOk={this.props.onChangePassword}
                onCancel={this.hideChangePasswordModal}
              />
              <Modal
                wrapClassName="otp-sign-in"
                visible={this.props.showOTPModal}
                closable={false}
                footer={null}
              >
                <EnterOTPLayout verifyOTP={this.props.onSubmitOTP} customer={this.props.profile} />
              </Modal>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
